import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nuestros Servicios</h2>
          <p>
            En <strong>SYSPAR TECHNOLOGIES</strong>, desarrollamos soluciones innovadoras y eficientes 
            para optimizar la gestión y el rendimiento de tu empresa.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "Cargando..."}
        </div>
      </div>
    </div>
  );
};
